<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<div class="EduTaxRebateWidgetGovMB__propertyForm">

		<Modal
		  v-show="showModal"
		  @close="showModal = false">
		  <template slot="header">
		    <span v-html="help.header"></span>
		  </template>
		  <template slot="body">
		    <span v-html="help.body"></span>
		  </template>
		 </Modal>

		<div v-for="(p,x) in value" class="EduTaxRebateWidgetGovMB__property" :key="`EduTaxRebateWidgetGovMB__property`+x">
			<button v-show="value.length > 1" class="EduTaxRebateWidgetGovMB__property--remove" type="button" @click="onRemoveProperty(x)" v-html="$t('removePropertyButton')"></button>
			<div class="EduTaxRebateWidgetGovMB__property--header" v-html="getPropertyHeader(x)"></div>
			<div class="EduTaxRebateWidgetGovMB__property--rollNumber">
				<label :for="`rollNumber`+x" v-html="$t('rollNumber')"></label>
				<input  :id="`rollNumber`+x" type="text" v-model="p.rollNumber.value"/>
			</div>

			<template v-for="(a, y) in p.assessment">
				<div class="EduTaxRebateWidgetGovMB__assessment" :key="`EduTaxRebateWidgetGovMB__assessment`+x+'_'+y">
				<button v-show="p.assessment.length > 1" class="EduTaxRebateWidgetGovMB__assessment--remove"  type="button" @click="onRemoveAssessment(x,y)" v-html="$t('removePropertyButton')"></button>
				<div class="EduTaxRebateWidgetGovMB__assessment--header" v-html="getAssessmentHeader(y)"></div>

				<div class="EduTaxRebateWidgetGovMB__assessment--row">
				<div class="EduTaxRebateWidgetGovMB__assessment--class">
					<label :for="`class`+y" v-html="$t('selectClass')"></label>
					<select :id="`class`+y" v-model="a.classType">
					  <option v-for="option in Property.getClassOptions" v-bind:value="option.id"  :key="`EduTaxRebateWidgetGovMB__assessmentoption`+x+'_'+y+'_'+option.id" v-html="$t('class.'+option.id)">

					  </option>
					</select>
				</div>
				<div class="EduTaxRebateWidgetGovMB__assessment--portionedAssessment">
					<label :for="`portionedAssessment`+y" v-html="$t('portionedAssessment')"></label>
					<currency-input class="EduTaxRebateWidgetGovMB__assessment--portionedAssessmentField" :distraction-free="false" :currency="getCurrency()" :locale="getCurrencyLocale()" :id="`portionedAssessment`+y" v-model="a.portionedAssessment.value" />
					  <span class="EduTaxRebateWidgetGovMB__tooltipButtonWrapper" :v-show="true">
					    <button class="EduTaxRebateWidgetGovMB__tooltipButton" type="button" @click="showHelpAssessment(a.classType)"><span>?</span></button>
					</span>
				</div>
				<div class="EduTaxRebateWidgetGovMB__assessment--schoolDivisionMillRate">
					<label :for="`schoolDivisionMillRate`+y" v-html="$t('schoolDivisionMillRate')"></label>
					<currency-input  class="EduTaxRebateWidgetGovMB__assessment--schoolDivisionMillRateField"  :currency="getMillrateFormat()" :precision="getMillRatePrecision()" locale="en" :id="`schoolDivisionMillRate`+y" v-model="a.schoolDivisionMillRate.value" />
					  <span class="EduTaxRebateWidgetGovMB__tooltipButtonWrapper" :v-show="true">
					    <button class="EduTaxRebateWidgetGovMB__tooltipButton" type="button" @click="showHelpMillRate(a.classType)"><span>?</span></button>
					</span>
				</div>
				</div>
				<div class="EduTaxRebateWidgetGovMB__assessment--row" v-if="a.classType == 'otherProperty'">
				<div class="EduTaxRebateWidgetGovMB__assessment--educationSupportLevy"><br/></div>
				<div class="EduTaxRebateWidgetGovMB__assessment--educationSupportLevy"><br/></div>
				<div class="EduTaxRebateWidgetGovMB__assessment--educationSupportLevy">
					<label :for="`educationSupportLevy`+y" v-html="$t('educationSupportLevy')"></label>
					<currency-input class="EduTaxRebateWidgetGovMB__assessment--educationSupportLevyField" :currency="getMillrateFormat()" :precision="getEducationSupportLevyPrecision()" locale="en" :id="`educationSupportLevy`+y" v-model="a.educationSupportLevy.value" />
					  <span class="EduTaxRebateWidgetGovMB__tooltipButtonWrapper" :v-show="true">
					    <button class="EduTaxRebateWidgetGovMB__tooltipButton" type="button" @click="showHelpLevy(a.classType)"><span>?</span></button>
					</span>
				</div>
				</div>


				</div>
			</template>
			<div class="EduTaxRebateWidgetGovMB__assessment--addWrapper"><button class="EduTaxRebateWidgetGovMB__assessment--add" type="button" @click="onAddAssessment(x)" v-html="$t('addAssessmentButton')"></button></div>

		</div>
		<div class="EduTaxRebateWidgetGovMB__property--addWrapper"><button class="EduTaxRebateWidgetGovMB__property--add" type="button" @click="onAddProperty()"><img src="@/assets/img/plus-icon.png" alt="" v-html="$t('addPropertyButton')"/> </button></div>

	</div>
</template>

<script>
import Property from '../models/Property'
// import numeral from 'numeral'
import Modal from '../components/Modal.vue';


export default {
	name: 'PropertyForm',
	props: ['value'],
	data() {
		return {
			showModal:false,
			classType:null,
			Property,
			help: {
				heading:null,
				body:null
			}
		}
	},
	components: {Modal},
	mounted() {

		// Close modal with 'esc' key
		document.addEventListener("keydown", (e) => {
		    if (e.keyCode == 27) {
		        this.showModal = false;
		    }
		});

   },
   watch: {
   },
	computed: {
	},
	methods: {
		getCurrency() {
			if (this.$store.state.lang == "fr") {
				return { prefix: '', suffix:' $'};
			} else {
				return { prefix: '$', suffix:''};
			}
		},
		getCurrencyLocale() {
			if (this.$store.state.lang == "fr") {
				return "fr";
			} else {
				return "en";
			}
		},


		showHelpAssessment(field) {
			this.classType = field;
			this.help.header = this.$t('help.portionedAssessment.'+field);
			this.help.body = "";
			if (this.$store.state.lang == "fr") {
				this.help.body += '<img src="'+this.$store.state.baseUrl + require("../assets/img/help-rm-mill-rate-fr.png")+'"/>';
				this.help.body += '<img src="'+this.$store.state.baseUrl + require("../assets/img/help-winnipeg-mill-rate-fr.png")+'"/>';
			} else {
				this.help.body += '<img src="'+this.$store.state.baseUrl + require("../assets/img/help-rm-mill-rate.png")+'"/>';
				this.help.body += '<img src="'+this.$store.state.baseUrl + require("../assets/img/help-winnipeg-mill-rate.png")+'"/>';
			}
			this.showModal = true;
		},

		showHelpMillRate(field) {
			this.classType = field;
			this.help.header = this.$t('help.schoolDivisionMillRate.'+field);
			this.help.body = "";
			if (this.$store.state.lang == "fr") {
				this.help.body += '<img src="'+this.$store.state.baseUrl + require("../assets/img/help-rm-mill-rate-fr.png")+'"/>';
				this.help.body += '<img src="'+this.$store.state.baseUrl + require("../assets/img/help-winnipeg-mill-rate-fr.png")+'"/>';
			} else {
				this.help.body += '<img src="'+this.$store.state.baseUrl + require("../assets/img/help-rm-mill-rate.png")+'"/>';
				this.help.body += '<img src="'+this.$store.state.baseUrl + require("../assets/img/help-winnipeg-mill-rate.png")+'"/>';
			}
			this.showModal = true;
		},
		showHelpLevy(field) {
			this.classType = field;
			this.help.header = this.$t('help.educationSupportLevy.'+field);
			this.help.body = "";
			if (this.$store.state.lang == "fr") {
				this.help.body += '<img src="'+this.$store.state.baseUrl + require("../assets/img/help-levy-mill-rate-fr.png")+'"/>';
			} else {
				this.help.body += '<img src="'+this.$store.state.baseUrl + require("../assets/img/help-levy-mill-rate.png")+'"/>';
			}
			this.showModal = true;
		},
		getPercentage() {
			return { prefix: '', suffix:'%'};
		},
		getMillrateFormat() {
			return { prefix: '', suffix:''};
		},
		getMillRatePrecision() {
			return { min: 0, max:8};
		},
		getEducationSupportLevyPrecision() {
			return { min: 0, max:8};
		},
		getPropertyHeader(x) {
			let num = x + 1;
			if (this.value[x].rollNumber.value != null && this.value[x].rollNumber.value != "") {
				return this.$t('propertyHeader') + "(" + this.value[x].rollNumber.value + ")"
			} else {
				return this.$t('propertyHeader') + num.leftZeroPad(2);
			}
		},
		getAssessmentHeader(x) {
			let num = x + 1;
			return this.$t('assessmentHeader') + num.leftZeroPad(2);
		},
		onRemoveProperty(x) {
			window.$bus.$emit("property:remove", x);
		},
		onAddProperty(x) {
			window.$bus.$emit("property:add");
		},

		onRemoveAssessment(p, a) {
			window.$bus.$emit("assessment:remove", p, a);
		},
		onAddAssessment(p) {
			window.$bus.$emit("assessment:add", p);
		},


		onSend() {
			/*
			if (this.message.value.trim() != "" && this.message.value != null) {
				this.$emit("message:newMessage", {
					message:this.message.value,
					replyToId: this.replyToId.value,
					sourceId: this.sourceId,
					sourceTable: this.sourceTable,
					done: () => {
						this.message.value = "";
					}
				});
			}
			*/
		}
	}
}
</script>
